<template>
	<div class="launch">
		<div class="btnbox">
			<div class="btnbox-left">
				<el-select
					v-if="shop_list.length"
					v-model="followShopId"
					size="small"
					filterable
					placeholder="跟进店铺"
					class="follow-shop-select"
					@change="onFollowShopChange"
				>
					<el-option
						v-for="(v, k) in shop_list"
						:key="k"
						:label="v.mall_name || v.shop_name"
						:value="v.id"
					/>
				</el-select>
				<el-button
					type="primary"
					size="small"
					:disabled="launchDisabled"
					@click="onlaunch()"
				>一键上架</el-button>
				<span v-if="launchDisabled" class="launch-disabled-tip">当前店铺有排队或执行中任务</span>
			</div>
			<div v-if="followShopId" class="queue-status-bar">
				<div class="queue-status-row">
					<span>等待 <b>{{ queueStatus.shop_pending }}</b></span>
					<span>执行中 <b>{{ queueStatus.shop_running }}</b></span>
					<span>今日完成 <b>{{ queueStatus.shop_done_today }}</b></span>
					<span>失败 <b>{{ queueStatus.shop_failed }}</b></span>
					<span>今日剩余 <b>{{ queueStatus.today_remaining }}</b></span>
					<span>全平台排队 <b>{{ queueStatus.queue_total }}</b></span>
				</div>
				<div v-if="queueStatus.in_safe_window === false" class="queue-safe-tip">
					将在夜间安全时段自动执行
					<span v-if="safeWindowsText">（{{ safeWindowsText }}）</span>
				</div>
			</div>
		</div>

		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0" v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.good_name" placeholder="商品标题"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.out_no" placeholder="款号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.cid" placeholder="分类">
							<el-option label="分类" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.product_cid" :key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.season" placeholder="发布季"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.sex" placeholder="性别"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left"/>
					<el-table-column label="图片" fixed="left" align="center" header-align="center" width="120px">
						<template slot-scope="scope">
							<div class="img">
								<img :src="scope.row.product_pic" v-if="scope.row.product_pic">
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="product_brand" label="品牌" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="out_no" label="款号" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column prop="good_no" label="商品编号" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column prop="good_name" label="商品标题" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column prop="product_color" label="颜色" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="product_cid_second" label="二级分类" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="product_cid_third" label="三级分类" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="product_sex" label="性别" align="center" header-align="center" min-width="50px">
					</el-table-column>
					<el-table-column prop="product_series" label="系列" align="center" header-align="center" min-width="90px">
					</el-table-column>
					<el-table-column prop="product_season" label="发布季" align="center" header-align="center" min-width="70px" fixed="right">
					</el-table-column>
				</el-table>
			</div>
		</div>
		
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	var EMPTY_QUEUE_STATUS = {
		queue_total: 0,
		shop_pending: 0,
		shop_running: 0,
		shop_done_today: 0,
		shop_failed: 0,
		today_remaining: 0,
		in_safe_window: true,
		safe_windows: [],
		currently_active: false,
	}

	export default {
		name: 'pddlaunch',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					good_name: "",
					out_no: "",
					brand: "",
					cid: "",
					season: "",
					sex: ""
				},
				alldata: [],
				shop_list: [],
				followShopId: '',
				queueStatus: Object.assign({}, EMPTY_QUEUE_STATUS),
				queueTimer: null,
			}
		},
		
		inject: ['appdata'],

		computed: {
			launchDisabled() {
				var pending = Number(this.queueStatus.shop_pending) || 0
				var running = Number(this.queueStatus.shop_running) || 0
				return pending > 0 || running > 0
			},
			safeWindowsText() {
				var windows = this.queueStatus.safe_windows
				if (!Array.isArray(windows) || !windows.length) {
					return ''
				}
				return windows.map(function(item) {
					var start = (item && item.start) || ''
					var end = (item && item.end) || ''
					if (!start && !end) {
						return ''
					}
					return start + '-' + end
				}).filter(Boolean).join('、')
			},
		},
		
		mounted() {
			this.onlist();
			this.onshop();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			this.clearQueuePoll();
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			resolveApiTip(resData, fallback) {
				var data = (resData && resData.data) || {}
				return data.msg || (resData && resData.msg) || (resData && resData.message) || fallback
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					good_name: "",
					out_no: "",
					brand: "",
					cid: "",
					season: "",
					sex: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/user/good_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(this.resolveApiTip(res.data, '获取列表失败'));
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			handleSelectionChange(val) {
				this.alldata = val;
			},
			
			onlaunch() {
				if (this.launchDisabled) {
					this.$message.warning('当前店铺有排队或执行中任务，请稍后再试');
					return;
				}
				if (!this.followShopId) {
					this.$message.warning('请先选择店铺');
					return;
				}
				if (!this.alldata.length) {
					this.$message.warning('必须选择一条数据');
					return;
				}
				var obj = {
					shop_id: this.followShopId,
					good_id: this.onids(this.alldata),
				}
				this.$axios.post('/api/user/pdd_good_add', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success(this.resolveApiTip(res.data, '已加入排队'));
						this.fetchQueueStatus()
						this.startQueuePoll()
					} else {
						this.$message.error(this.resolveApiTip(res.data, '提交失败'));
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onshop() {
				var obj = {
					page: 1,
					limit: 99999
				};
								
				this.$axios.post('api/retail_shop/list', obj).then(res => {
					if (res.data.code == 0) {
						this.shop_list = (res.data.data && res.data.data.list) || [];
						if (!this.followShopId && this.shop_list.length) {
							this.followShopId = this.shop_list[0].id
						}
						if (this.followShopId) {
							this.fetchQueueStatus()
							this.startQueuePoll()
						}
					} else {
						this.$message.error(this.resolveApiTip(res.data, '获取店铺失败'));
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onFollowShopChange() {
				this.fetchQueueStatus()
				this.startQueuePoll()
			},

			clearQueuePoll() {
				if (this.queueTimer) {
					clearInterval(this.queueTimer)
					this.queueTimer = null
				}
			},

			startQueuePoll() {
				this.clearQueuePoll()
				if (!this.followShopId) {
					return
				}
				this.queueTimer = setInterval(function() {
					this.fetchQueueStatus()
				}.bind(this), 30000)
			},

			fetchQueueStatus() {
				if (!this.followShopId) {
					this.queueStatus = Object.assign({}, EMPTY_QUEUE_STATUS)
					return
				}
				this.$axios.post('/api/user/listing_queue_status', {
					shop_id: this.followShopId,
				}).then(function(res) {
					if (res.data.code == 0) {
						var data = res.data.data || {}
						this.queueStatus = Object.assign({}, EMPTY_QUEUE_STATUS, data)
					}
				}.bind(this)).catch(function(err) {
					console.log(err)
				})
			},
			
			onids(arrs) {
				var arr = [];
				arrs.forEach((v) => {
					arr.push(v.id);
				})
				return arr.join(',')
			},
		}
	}
</script>

<style scoped lang="less">
	.launch {
		height: 100%;
		padding: 10px 10px 0 0;
		background-color: #fff;
		box-sizing: border-box;
	}

	.btnbox {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 16px;
		margin-bottom: 8px;
	}

	.btnbox-left {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		flex-shrink: 0;
		gap: 8px;
	}

	.follow-shop-select {
		width: 220px;
	}

	.launch-disabled-tip {
		color: #e6a23c;
		font-size: 12px;
	}

	.queue-status-bar {
		flex: 0 1 auto;
		max-width: 62%;
		margin-left: auto;
		padding: 6px 12px;
		background: #f7f8fa;
		border: 1px solid #ebeef5;
		font-size: 12px;
		color: #606266;
		line-height: 1.6;
		text-align: right;
	}

	.queue-status-row {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		gap: 12px;

		b {
			color: #303133;
			font-weight: 600;
		}
	}

	.queue-safe-tip {
		margin-top: 2px;
		color: #e6a23c;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
	
	.img {
		width: 100px;
		img {
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pdd/launch.vue